(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea579"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea579"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gfzyP", function(module, exports) {
exports = module.exports = trim;
function trim(str) {
    return str.replace(/^\s*|\s*$/g, "");
}
exports.left = function(str) {
    return str.replace(/^\s*/, "");
};
exports.right = function(str) {
    return str.replace(/\s*$/, "");
};

});

var $d51c0ce366089ba6$exports = {};
"use strict";
var $0bfe44249481e3bf$exports = {};
"use strict";
var $ae6ec57466285dd1$exports = {};
"use strict";
var $c05f518a29f04c8a$exports = {};
"use strict";
var $c05f518a29f04c8a$var$hop = Object.prototype.hasOwnProperty;
var $c05f518a29f04c8a$var$strCharAt = String.prototype.charAt;
var $c05f518a29f04c8a$var$toStr = Object.prototype.toString;
/**
 * Returns the character at a given index.
 *
 * @param {string} str
 * @param {number} index
 * @return {string|undefined}
 */ // TODO: Move to a library
var $c05f518a29f04c8a$var$charAt = function(str, index) {
    return $c05f518a29f04c8a$var$strCharAt.call(str, index);
};
/**
 * hasOwnProperty, wrapped as a function.
 *
 * @name has
 * @api private
 * @param {*} context
 * @param {string|number} prop
 * @return {boolean}
 */ // TODO: Move to a library
var $c05f518a29f04c8a$var$has = function has(context, prop) {
    return $c05f518a29f04c8a$var$hop.call(context, prop);
};
/**
 * Returns true if a value is a string, otherwise false.
 *
 * @name isString
 * @api private
 * @param {*} val
 * @return {boolean}
 */ // TODO: Move to a library
var $c05f518a29f04c8a$var$isString = function isString(val) {
    return $c05f518a29f04c8a$var$toStr.call(val) === "[object String]";
};
/**
 * Returns true if a value is array-like, otherwise false. Array-like means a
 * value is not null, undefined, or a function, and has a numeric `length`
 * property.
 *
 * @name isArrayLike
 * @api private
 * @param {*} val
 * @return {boolean}
 */ // TODO: Move to a library
var $c05f518a29f04c8a$var$isArrayLike = function isArrayLike(val) {
    return val != null && typeof val !== "function" && typeof val.length === "number";
};
/**
 * indexKeys
 *
 * @name indexKeys
 * @api private
 * @param {} target
 * @param {Function} pred
 * @return {Array}
 */ var $c05f518a29f04c8a$var$indexKeys = function indexKeys(target, pred) {
    pred = pred || $c05f518a29f04c8a$var$has;
    var results = [];
    for(var i = 0, len = target.length; i < len; i += 1)if (pred(target, i)) results.push(String(i));
    return results;
};
/**
 * Returns an array of an object's owned keys.
 *
 * @name objectKeys
 * @api private
 * @param {*} target
 * @param {Function} pred Predicate function used to include/exclude values from
 * the resulting array.
 * @return {Array}
 */ var $c05f518a29f04c8a$var$objectKeys = function objectKeys(target, pred) {
    pred = pred || $c05f518a29f04c8a$var$has;
    var results = [];
    for(var key in target)if (pred(target, key)) results.push(String(key));
    return results;
};
/**
 * Creates an array composed of all keys on the input object. Ignores any non-enumerable properties.
 * More permissive than the native `Object.keys` function (non-objects will not throw errors).
 *
 * @name keys
 * @api public
 * @category Object
 * @param {Object} source The value to retrieve keys from.
 * @return {Array} An array containing all the input `source`'s keys.
 * @example
 * keys({ likes: 'avocado', hates: 'pineapple' });
 * //=> ['likes', 'pineapple'];
 *
 * // Ignores non-enumerable properties
 * var hasHiddenKey = { name: 'Tim' };
 * Object.defineProperty(hasHiddenKey, 'hidden', {
 *   value: 'i am not enumerable!',
 *   enumerable: false
 * })
 * keys(hasHiddenKey);
 * //=> ['name'];
 *
 * // Works on arrays
 * keys(['a', 'b', 'c']);
 * //=> ['0', '1', '2']
 *
 * // Skips unpopulated indices in sparse arrays
 * var arr = [1];
 * arr[4] = 4;
 * keys(arr);
 * //=> ['0', '4']
 */ var $c05f518a29f04c8a$var$keys = function keys(source) {
    if (source == null) return [];
    // IE6-8 compatibility (string)
    if ($c05f518a29f04c8a$var$isString(source)) return $c05f518a29f04c8a$var$indexKeys(source, $c05f518a29f04c8a$var$charAt);
    // IE6-8 compatibility (arguments)
    if ($c05f518a29f04c8a$var$isArrayLike(source)) return $c05f518a29f04c8a$var$indexKeys(source, $c05f518a29f04c8a$var$has);
    return $c05f518a29f04c8a$var$objectKeys(source);
};
/*
 * Exports.
 */ $c05f518a29f04c8a$exports = $c05f518a29f04c8a$var$keys;


var $ae6ec57466285dd1$var$objToString = Object.prototype.toString;
/**
 * Tests if a value is a number.
 *
 * @name isNumber
 * @api private
 * @param {*} val The value to test.
 * @return {boolean} Returns `true` if `val` is a number, otherwise `false`.
 */ // TODO: Move to library
var $ae6ec57466285dd1$var$isNumber = function isNumber(val) {
    var type = typeof val;
    return type === "number" || type === "object" && $ae6ec57466285dd1$var$objToString.call(val) === "[object Number]";
};
/**
 * Tests if a value is an array.
 *
 * @name isArray
 * @api private
 * @param {*} val The value to test.
 * @return {boolean} Returns `true` if the value is an array, otherwise `false`.
 */ // TODO: Move to library
var $ae6ec57466285dd1$var$isArray = typeof Array.isArray === "function" ? Array.isArray : function isArray(val) {
    return $ae6ec57466285dd1$var$objToString.call(val) === "[object Array]";
};
/**
 * Tests if a value is array-like. Array-like means the value is not a function and has a numeric
 * `.length` property.
 *
 * @name isArrayLike
 * @api private
 * @param {*} val
 * @return {boolean}
 */ // TODO: Move to library
var $ae6ec57466285dd1$var$isArrayLike = function isArrayLike(val) {
    return val != null && ($ae6ec57466285dd1$var$isArray(val) || val !== "function" && $ae6ec57466285dd1$var$isNumber(val.length));
};
/**
 * Internal implementation of `each`. Works on arrays and array-like data structures.
 *
 * @name arrayEach
 * @api private
 * @param {Function(value, key, collection)} iterator The function to invoke per iteration.
 * @param {Array} array The array(-like) structure to iterate over.
 * @return {undefined}
 */ var $ae6ec57466285dd1$var$arrayEach = function arrayEach(iterator, array) {
    for(var i = 0; i < array.length; i += 1){
        // Break iteration early if `iterator` returns `false`
        if (iterator(array[i], i, array) === false) break;
    }
};
/**
 * Internal implementation of `each`. Works on objects.
 *
 * @name baseEach
 * @api private
 * @param {Function(value, key, collection)} iterator The function to invoke per iteration.
 * @param {Object} object The object to iterate over.
 * @return {undefined}
 */ var $ae6ec57466285dd1$var$baseEach = function baseEach(iterator, object) {
    var ks = $c05f518a29f04c8a$exports(object);
    for(var i = 0; i < ks.length; i += 1){
        // Break iteration early if `iterator` returns `false`
        if (iterator(object[ks[i]], ks[i], object) === false) break;
    }
};
/**
 * Iterate over an input collection, invoking an `iterator` function for each element in the
 * collection and passing to it three arguments: `(value, index, collection)`. The `iterator`
 * function can end iteration early by returning `false`.
 *
 * @name each
 * @api public
 * @param {Function(value, key, collection)} iterator The function to invoke per iteration.
 * @param {Array|Object|string} collection The collection to iterate over.
 * @return {undefined} Because `each` is run only for side effects, always returns `undefined`.
 * @example
 * var log = console.log.bind(console);
 *
 * each(log, ['a', 'b', 'c']);
 * //-> 'a', 0, ['a', 'b', 'c']
 * //-> 'b', 1, ['a', 'b', 'c']
 * //-> 'c', 2, ['a', 'b', 'c']
 * //=> undefined
 *
 * each(log, 'tim');
 * //-> 't', 2, 'tim'
 * //-> 'i', 1, 'tim'
 * //-> 'm', 0, 'tim'
 * //=> undefined
 *
 * // Note: Iteration order not guaranteed across environments
 * each(log, { name: 'tim', occupation: 'enchanter' });
 * //-> 'tim', 'name', { name: 'tim', occupation: 'enchanter' }
 * //-> 'enchanter', 'occupation', { name: 'tim', occupation: 'enchanter' }
 * //=> undefined
 */ var $ae6ec57466285dd1$var$each = function each(iterator, collection) {
    return ($ae6ec57466285dd1$var$isArrayLike(collection) ? $ae6ec57466285dd1$var$arrayEach : $ae6ec57466285dd1$var$baseEach).call(this, iterator, collection);
};
/*
 * Exports.
 */ $ae6ec57466285dd1$exports = $ae6ec57466285dd1$var$each;


/**
 * Reduces all the values in a collection down into a single value. Does so by iterating through the
 * collection from left to right, repeatedly calling an `iterator` function and passing to it four
 * arguments: `(accumulator, value, index, collection)`.
 *
 * Returns the final return value of the `iterator` function.
 *
 * @name foldl
 * @api public
 * @param {Function} iterator The function to invoke per iteration.
 * @param {*} accumulator The initial accumulator value, passed to the first invocation of `iterator`.
 * @param {Array|Object} collection The collection to iterate over.
 * @return {*} The return value of the final call to `iterator`.
 * @example
 * foldl(function(total, n) {
 *   return total + n;
 * }, 0, [1, 2, 3]);
 * //=> 6
 *
 * var phonebook = { bob: '555-111-2345', tim: '655-222-6789', sheila: '655-333-1298' };
 *
 * foldl(function(results, phoneNumber) {
 *  if (phoneNumber[0] === '6') {
 *    return results.concat(phoneNumber);
 *  }
 *  return results;
 * }, [], phonebook);
 * // => ['655-222-6789', '655-333-1298']
 */ var $0bfe44249481e3bf$var$foldl = function foldl(iterator, accumulator, collection) {
    if (typeof iterator !== "function") throw new TypeError("Expected a function but received a " + typeof iterator);
    $ae6ec57466285dd1$exports(function(val, i, collection) {
        accumulator = iterator(accumulator, val, i, collection);
    }, collection);
    return accumulator;
};
/*
 * Exports.
 */ $0bfe44249481e3bf$exports = $0bfe44249481e3bf$var$foldl;


/**
 * Module dependencies.
 */ /**
 * Parse the given query `str`.
 *
 * @param {String} str
 * @return {Object}
 * @api public
 */ var $4a184e24a91a3b54$export$98e6a39c04603d36;
/**
 * Stringify the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api public
 */ var $4a184e24a91a3b54$export$fac44ee5b035f737;

var $gfzyP = parcelRequire("gfzyP");
var $d15ed282dec3c536$exports = {};
/**
 * toString ref.
 */ var $d15ed282dec3c536$var$toString = Object.prototype.toString;
/**
 * Return the type of `val`.
 *
 * @param {Mixed} val
 * @return {String}
 * @api public
 */ $d15ed282dec3c536$exports = function(val) {
    switch($d15ed282dec3c536$var$toString.call(val)){
        case "[object Date]":
            return "date";
        case "[object RegExp]":
            return "regexp";
        case "[object Arguments]":
            return "arguments";
        case "[object Array]":
            return "array";
        case "[object Error]":
            return "error";
    }
    if (val === null) return "null";
    if (val === undefined) return "undefined";
    if (val !== val) return "nan";
    if (val && val.nodeType === 1) return "element";
    val = val.valueOf ? val.valueOf() : Object.prototype.valueOf.apply(val);
    return typeof val;
};


var $4a184e24a91a3b54$var$pattern = /(\w+)\[(\d+)\]/;
/**
 * Safely encode the given string
 * 
 * @param {String} str
 * @return {String}
 * @api private
 */ var $4a184e24a91a3b54$var$encode = function(str) {
    try {
        return encodeURIComponent(str);
    } catch (e) {
        return str;
    }
};
/**
 * Safely decode the string
 * 
 * @param {String} str
 * @return {String}
 * @api private
 */ var $4a184e24a91a3b54$var$decode = function(str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, " "));
    } catch (e) {
        return str;
    }
};
$4a184e24a91a3b54$export$98e6a39c04603d36 = function(str) {
    if ("string" != typeof str) return {};
    str = $gfzyP(str);
    if ("" == str) return {};
    if ("?" == str.charAt(0)) str = str.slice(1);
    var obj = {};
    var pairs = str.split("&");
    for(var i = 0; i < pairs.length; i++){
        var parts = pairs[i].split("=");
        var key = $4a184e24a91a3b54$var$decode(parts[0]);
        var m;
        if (m = $4a184e24a91a3b54$var$pattern.exec(key)) {
            obj[m[1]] = obj[m[1]] || [];
            obj[m[1]][m[2]] = $4a184e24a91a3b54$var$decode(parts[1]);
            continue;
        }
        obj[parts[0]] = null == parts[1] ? "" : $4a184e24a91a3b54$var$decode(parts[1]);
    }
    return obj;
};
$4a184e24a91a3b54$export$fac44ee5b035f737 = function(obj) {
    if (!obj) return "";
    var pairs = [];
    for(var key in obj){
        var value = obj[key];
        if ("array" == $d15ed282dec3c536$exports(value)) {
            for(var i = 0; i < value.length; ++i)pairs.push($4a184e24a91a3b54$var$encode(key + "[" + i + "]") + "=" + $4a184e24a91a3b54$var$encode(value[i]));
            continue;
        }
        pairs.push($4a184e24a91a3b54$var$encode(key) + "=" + $4a184e24a91a3b54$var$encode(obj[key]));
    }
    return pairs.join("&");
};


var $d51c0ce366089ba6$require$parse = $4a184e24a91a3b54$export$98e6a39c04603d36;
/**
 * hasOwnProperty reference.
 */ var $d51c0ce366089ba6$var$has = Object.prototype.hasOwnProperty;
/**
 * Get all utm params from the given `querystring`
 *
 * @param {String} query
 * @return {Object}
 * @api private
 */ function $d51c0ce366089ba6$var$utm(query) {
    // Remove leading ? if present
    if (query.charAt(0) === "?") query = query.substring(1);
    query = query.replace(/\?/g, "&");
    var param;
    var params = $d51c0ce366089ba6$require$parse(query);
    var results = {};
    for(var key in params){
        if ($d51c0ce366089ba6$var$has.call(params, key)) {
            if (key.substr(0, 4) === "utm_") {
                param = key.substr(4);
                if (param === "campaign") param = "name";
                results[param] = params[key];
            }
        }
    }
    return results;
}
var $d51c0ce366089ba6$var$allowedKeys = {
    name: true,
    term: true,
    source: true,
    medium: true,
    content: true
};
/**
 * Get strict utm params - from the given `querystring`
 *
 * @param {String} query
 * @return {Object}
 * @api private
 */ function $d51c0ce366089ba6$var$strict(query) {
    return $0bfe44249481e3bf$exports(function(acc, val, key) {
        if ($d51c0ce366089ba6$var$has.call($d51c0ce366089ba6$var$allowedKeys, key)) acc[key] = val;
        return acc;
    }, {}, $d51c0ce366089ba6$var$utm(query));
}
/*
 * Exports.
 */ $d51c0ce366089ba6$exports = $d51c0ce366089ba6$var$utm;
$d51c0ce366089ba6$exports.strict = $d51c0ce366089ba6$var$strict;


let $0acf8dea35ca9a76$var$utmObj = (0, (/*@__PURE__*/$parcel$interopDefault($d51c0ce366089ba6$exports)))(window.location.href);
let $0acf8dea35ca9a76$var$isTest = window.location.href.includes("test");
let $0acf8dea35ca9a76$var$platform = $0acf8dea35ca9a76$var$isTest ? "test" : $0acf8dea35ca9a76$var$utmObj.source ? $0acf8dea35ca9a76$var$utmObj.source : "organic";
let $0acf8dea35ca9a76$var$page = document.getElementById("main").dataset.pageName;
if (!$0acf8dea35ca9a76$var$page || $0acf8dea35ca9a76$var$page.length < 1) $0acf8dea35ca9a76$var$page = window.location.href;
document.addEventListener("DOMContentLoaded", (e)=>{
    let calendarButtons = document.querySelectorAll(".event-tracked");
    calendarButtons.forEach((button)=>{
        button.addEventListener("click", (e)=>{
            let category = button.classList.contains("calendar") ? "calendar" : "live";
            if (category === "live") $0acf8dea35ca9a76$var$page = button.dataset.liveName;
            $0acf8dea35ca9a76$var$trackEvent($0acf8dea35ca9a76$var$platform, category, $0acf8dea35ca9a76$var$page);
        });
    });
    // update links on the page if using UTM
    if ($0acf8dea35ca9a76$var$utmObj.source) {
        let anchors = [
            ...document.querySelectorAll("a")
        ];
        anchors.map((anchor)=>{
            let link = anchor.href;
            if (!link.includes("#") && !link.includes(".ics") && link.length > 0) anchor.href += "?utm_source=" + $0acf8dea35ca9a76$var$utmObj.source;
        });
    }
});
let $0acf8dea35ca9a76$var$formContainers = document.querySelectorAll(".wpcf7");
$0acf8dea35ca9a76$var$formContainers.forEach((formContainer)=>{
    formContainer.addEventListener("wpcf7mailsent", (e)=>{
        let category = formContainer.querySelector("form").classList.contains("sms") ? "sms" : "enquiry";
        $0acf8dea35ca9a76$var$trackEvent($0acf8dea35ca9a76$var$platform, category, $0acf8dea35ca9a76$var$page);
    });
});
function $0acf8dea35ca9a76$var$trackEvent(platform, category, page) {
    console.log("Event logged: " + platform + "---" + category + "---" + page);
    _hmt.push([
        "_trackEvent",
        platform,
        category,
        page
    ]);
}


var $1597e095310a24b9$var$ua = navigator.userAgent.toLowerCase();
var $1597e095310a24b9$var$isBrowser = true;
var $1597e095310a24b9$var$isToutiao = false;
if ($1597e095310a24b9$var$ua.match(/MicroMessenger/i) == "micromessenger" || $1597e095310a24b9$var$ua.match(/WeiBo/i) == "weibo" || $1597e095310a24b9$var$ua.match(/QQ/i) == "qq" || $1597e095310a24b9$var$ua.includes("newsarticle")) {
    $1597e095310a24b9$var$isBrowser = false;
    if ($1597e095310a24b9$var$ua.includes("newsarticle")) $1597e095310a24b9$var$isToutiao = true;
}
let $1597e095310a24b9$var$calendarButtons = document.querySelectorAll(".calendar");
let $1597e095310a24b9$var$calendarTip = document.querySelector(".instruction-tip");
if ($1597e095310a24b9$var$isToutiao) $1597e095310a24b9$var$calendarTip.style.display = "none";
$1597e095310a24b9$var$calendarButtons.forEach((button)=>{
    if (!$1597e095310a24b9$var$isBrowser) button.href = "javascript: void(0)";
    if ($1597e095310a24b9$var$isToutiao) button.style.display = "none";
    else button.addEventListener("click", (e)=>{
        if (!$1597e095310a24b9$var$isBrowser) document.body.classList.add("instruction-shown");
    });
});
let $1597e095310a24b9$var$closeButton = document.getElementById("instruction-close");
$1597e095310a24b9$var$closeButton.addEventListener("click", ()=>{
    document.body.classList.remove("instruction-shown");
});




})();
//# sourceMappingURL=app.js.map
